import { useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function TermsOfService() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#F0F4F8] to-white">
      <Navbar />
      
      <main className="pt-32 pb-20">
        <div className="max-w-4xl mx-auto px-6">
          <h1 className="text-4xl md:text-5xl font-serif font-bold text-[#1E5A8E] mb-8">
            Terms of Service
          </h1>
          
          <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
            <div className="prose prose-lg max-w-none">

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-[#2F7FB7] mb-4">
                  1. Acceptance of Terms
                </h2>
                <p className="text-[#4A5568] leading-relaxed">
                  By accessing and using the RECOVER application, you accept and agree to be bound by the terms and provision of this agreement.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-[#2F7FB7] mb-4">
                  2. Use License
                </h2>
                <p className="text-[#4A5568] leading-relaxed">
                  Permission is granted to temporarily download one copy of RECOVER for personal, non-commercial transitory viewing only.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-[#2F7FB7] mb-4">
                  3. Disclaimer
                </h2>
                <p className="text-[#4A5568] leading-relaxed">
                  The materials within RECOVER are provided on an 'as is' basis. RECOVER makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-[#2F7FB7] mb-4">
                  4. Limitations
                </h2>
                <p className="text-[#4A5568] leading-relaxed">
                  In no event shall RECOVER or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use RECOVER.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-[#2F7FB7] mb-4">
                  5. Revisions
                </h2>
                <p className="text-[#4A5568] leading-relaxed">
                  RECOVER may revise these terms of service at any time without notice. By using this application, you are agreeing to be bound by the then current version of these terms of service.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-[#2F7FB7] mb-4">
                  6. Contact Information
                </h2>
                <p className="text-[#4A5568] leading-relaxed">
                  If you have any questions about these Terms of Service, please contact us through the app or visit our support page.
                </p>
              </section>
            </div>
          </div>

          <div className="mt-8 text-center">
            <p className="text-[#6B7280] text-sm">
              Last updated: January 2025
            </p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
